import React from "react";

function Privacy() {
  return (
    <div className="text-white px-6 py-16 max-w-3xl mx-auto mt-32">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy for Digital Ladyland Chord Finder</h1>
      <p className="text-gray-300 mb-2">Effective Date: May 29, 2025</p>

      <div className="space-y-4 text-white/90 leading-relaxed mt-4">
        <p>
          Digital Ladyland Chord Finder (“we”, “us”, or “our”) is committed to protecting your privacy. This privacy policy outlines how we handle your data when you use our app.
        </p>

        <h2 className="text-xl font-semibold">1. Information We Collect</h2>
        <p>
          We do not collect personally identifiable information from users. The app accesses your device microphone only when you tap "Record" to analyze audio in real time and detect chords. No recordings are stored or transmitted unless explicitly needed for processing.
        </p>

        <h2 className="text-xl font-semibold">2. Microphone Access</h2>
        <p>
          The app requires microphone access solely for audio analysis during a chord detection session. This data is processed locally on your device or securely sent to our backend for real-time analysis. We do not store, share, or use this data for any other purpose.
        </p>

        <h2 className="text-xl font-semibold">3. No Account or Login Required</h2>
        <p>
          You are not required to create an account or log in to use the app. We do not collect email addresses, names, or any personal credentials.
        </p>

        <h2 className="text-xl font-semibold">4. Analytics & Tracking</h2>
        <p>
          We do not use third-party tracking tools or analytics services that collect user data.
        </p>

        <h2 className="text-xl font-semibold">5. Children’s Privacy</h2>
        <p>
          This app is not directed to children under 13. We do not knowingly collect personal data from children. If you believe we have inadvertently collected such information, please contact us for removal.
        </p>

        <h2 className="text-xl font-semibold">6. Data Security</h2>
        <p>
          We take appropriate measures to protect any temporary data during audio processing. No data is retained after analysis is completed.
        </p>

        <h2 className="text-xl font-semibold">7. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. The latest version will always be available at 
          <a href="/privacy" className="underline text-indigo-400">digitalladyland.com/privacy</a>.
        </p>

        <h2 className="text-xl font-semibold">8. Contact Us</h2>
        <p>
          If you have any questions or concerns about this policy, please contact:
        </p>
        <p>
          <strong>Digital Ladyland</strong><br />
          📧 <a href="mailto:support@digitalladyland.com" className="underline text-indigo-400">support@digitalladyland.com</a><br />
          🌐 <a href="https://www.digitalladyland.com" className="underline text-indigo-400">https://www.digitalladyland.com</a>
        </p>
      </div>
    </div>
  );
}

export default Privacy;
